import { getStore } from "../store/store";
import type { MailFolder } from "owa-graph-schema";
import type { FolderTableState } from "./isFolderOrSubFolderOfDistinguishedFolder";
import isFolderOrSubFolderOfDistinguishedFolder, { isUnderDistinguishedFolder, } from "./isFolderOrSubFolderOfDistinguishedFolder";

export default function isFolderUnderMsg(folder: MailFolder, state: FolderTableState = { folderTable: getStore().folderTable }): boolean {
    return isUnderDistinguishedFolder(folder, "msgfolderroot", state);
}

/**
 * @param folderId - Id of folder for which we are checking
 * @returns boolean - true if folder is primary root or a subfolder of primary root
 */
export function isFolderOrSubFolderOfMsgRoot(folderId: string): boolean {
    return isFolderOrSubFolderOfDistinguishedFolder(getStore().folderTable.get(folderId), "msgfolderroot");
}
